import { useQuery } from "@tanstack/react-query";
import { SCHEDULE_POLL_MS } from "../../../../shared/config/polling";
import { scheduleKeys } from "../schedule.keys";
import { scheduleApi } from "../service";

/**
 * The worker's one open work session, for the live banner on the worker home. The lifecycle
 * mutations invalidate `scheduleKeys.all`, so the banner updates immediately after every
 * phase action; polling only covers changes made on another device.
 */
export function useCurrentWorkSession(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: scheduleKeys.workSession(),
    queryFn: async () => {
      const { data } = await scheduleApi.getCurrentWorkSession();
      return data.session;
    },
    enabled: options.enabled ?? true,
    refetchInterval: SCHEDULE_POLL_MS,
    refetchIntervalInBackground: false,
  });
}
